import { render, staticRenderFns } from "./createEvento.vue?vue&type=template&id=4ccbf698&scoped=true&"
import script from "./createEvento.vue?vue&type=script&lang=js&"
export * from "./createEvento.vue?vue&type=script&lang=js&"
import style0 from "./createEvento.vue?vue&type=style&index=0&id=4ccbf698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbf698",
  null
  
)

export default component.exports